package com.yogaaicoach.pages.workout.data.models

import com.yogaaicoach.common.network.serializers.UuidSerializer
import kotlinx.serialization.Serializable
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

@OptIn(ExperimentalUuidApi::class)
@Serializable
data class PostWorkoutFeedbackRequest(
    @Serializable(with = UuidSerializer::class) val workoutGuid: Uuid,
    val difficulty: Int
)
